import { callAuthToken } from '..'
import { getBrand, getBrandGroup, getPurposeId } from '../../core/pure/Env'
import { getAuth0Feature } from '../../core/pure/Window'
import { api, apiPath } from './util'

export interface Consent {
  id: string
  name: string
  title: string
  version: string
  status: 'ToBeRequested' | 'Accepted' | 'Declined'
}

export interface ConsentThatExpires extends Consent {
  expires: number
}

export const getAccountConsent = async (accountId: string): Promise<Consent> => {
  const isAuth0Enabled = getAuth0Feature()

  const token = await callAuthToken()

  return await fetch(
    `${api}${apiPath}${isAuth0Enabled ? getBrandGroup() : getBrand()}/account/${accountId}/consent/${getPurposeId()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  ).then((res) => {
    if (res.ok) return res.json()
    throw new Error(res.statusText)
  })
}

export const getAccountConsents = async (accountId: string): Promise<Consent[]> => {
  const isAuth0Enabled = getAuth0Feature()

  const token = await callAuthToken()

  return await fetch(`${api}${apiPath}${isAuth0Enabled ? getBrandGroup() : getBrand()}/account/${accountId}/consent`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }).then((res) => {
    if (res.ok) return res.json()
    throw new Error(res.statusText)
  })
}
